// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/password_push/v1/password_push_flow_visibility_binding.proto" (package "c1.api.password_push.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { AppEntitlementRef } from "../../app/v1/app_refs";
// ====== Messages ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowVisibilityBindingRef
 */
export interface PasswordPushFlowVisibilityBindingRef {
    /**
     * @generated from protobuf field: string password_push_flow_id = 1;
     */
    passwordPushFlowId: string;
}
// ====== Mutate ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowVisibilityBindingServiceMutateRequest
 */
export interface PasswordPushFlowVisibilityBindingServiceMutateRequest {
    /**
     * @generated from protobuf field: string password_push_flow_id = 1;
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 2;
     */
    appEntitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowVisibilityBindingServiceMutateResponse
 */
export interface PasswordPushFlowVisibilityBindingServiceMutateResponse {
    /**
     * @generated from protobuf field: string password_push_flow_id = 1;
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 2;
     */
    appEntitlementRefs: AppEntitlementRef[];
}
// ====== List ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowVisibilityBindingServiceListRequest
 */
export interface PasswordPushFlowVisibilityBindingServiceListRequest {
    /**
     * @generated from protobuf field: string password_push_flow_id = 1;
     */
    passwordPushFlowId: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowVisibilityBindingServiceListResponse
 */
export interface PasswordPushFlowVisibilityBindingServiceListResponse {
    /**
     * @generated from protobuf field: string password_push_flow_id = 1;
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 2;
     */
    appEntitlementRefs: AppEntitlementRef[];
}
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowVisibilityBindingRef$Type extends MessageType<PasswordPushFlowVisibilityBindingRef> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowVisibilityBindingRef", [
            { no: 1, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowVisibilityBindingRef
 */
export const PasswordPushFlowVisibilityBindingRef = new PasswordPushFlowVisibilityBindingRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowVisibilityBindingServiceMutateRequest$Type extends MessageType<PasswordPushFlowVisibilityBindingServiceMutateRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowVisibilityBindingServiceMutateRequest", [
            { no: 1, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowVisibilityBindingServiceMutateRequest
 */
export const PasswordPushFlowVisibilityBindingServiceMutateRequest = new PasswordPushFlowVisibilityBindingServiceMutateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowVisibilityBindingServiceMutateResponse$Type extends MessageType<PasswordPushFlowVisibilityBindingServiceMutateResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowVisibilityBindingServiceMutateResponse", [
            { no: 1, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowVisibilityBindingServiceMutateResponse
 */
export const PasswordPushFlowVisibilityBindingServiceMutateResponse = new PasswordPushFlowVisibilityBindingServiceMutateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowVisibilityBindingServiceListRequest$Type extends MessageType<PasswordPushFlowVisibilityBindingServiceListRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowVisibilityBindingServiceListRequest", [
            { no: 1, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowVisibilityBindingServiceListRequest
 */
export const PasswordPushFlowVisibilityBindingServiceListRequest = new PasswordPushFlowVisibilityBindingServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowVisibilityBindingServiceListResponse$Type extends MessageType<PasswordPushFlowVisibilityBindingServiceListResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowVisibilityBindingServiceListResponse", [
            { no: 1, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowVisibilityBindingServiceListResponse
 */
export const PasswordPushFlowVisibilityBindingServiceListResponse = new PasswordPushFlowVisibilityBindingServiceListResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.password_push.v1.PasswordPushFlowVisibilityBindingService
 */
export const PasswordPushFlowVisibilityBindingService = new ServiceType("c1.api.password_push.v1.PasswordPushFlowVisibilityBindingService", [
    { name: "Mutate", options: { "authz.method": { role: "EDITOR" } }, I: PasswordPushFlowVisibilityBindingServiceMutateRequest, O: PasswordPushFlowVisibilityBindingServiceMutateResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPushFlowVisibilityBindingServiceListRequest, O: PasswordPushFlowVisibilityBindingServiceListResponse }
]);
